// Auth Utility für Token Management und Persistence
// Verhindert ungewollte Logouts und managed Token-Lifecycle

export const authUtils = {
  /**
   * Speichert Token und User-Daten im localStorage
   */
  setAuth: (token, user) => {
    try {
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('userId', user.id);
      localStorage.setItem('userRole', user.role);
      localStorage.setItem('subscriptionTier', user.subscriptionTier || 'starter');
      
      // Token Expiry: 24 Stunden ab jetzt
      const expiryTime = Date.now() + (24 * 60 * 60 * 1000);
      localStorage.setItem('tokenExpiry', expiryTime.toString());
      
      console.log('✅ Auth data saved to localStorage');
    } catch (error) {
      console.error('❌ Error saving auth data:', error);
    }
  },

  /**
   * Holt Token aus localStorage und prüft Gültigkeit
   */
  getToken: () => {
    try {
      const token = localStorage.getItem('token');
      const expiry = localStorage.getItem('tokenExpiry');
      
      if (!token || !expiry) {
        return null;
      }
      
      const expiryTime = parseInt(expiry);
      const now = Date.now();
      
      // Check if token is expired
      if (now >= expiryTime) {
        console.log('⏰ Token expired, clearing auth data');
        authUtils.clearAuth();
        return null;
      }
      
      return token;
    } catch (error) {
      console.error('❌ Error getting token:', error);
      return null;
    }
  },

  /**
   * Holt User-Daten aus localStorage
   */
  getUser: () => {
    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        return null;
      }
      return JSON.parse(userStr);
    } catch (error) {
      console.error('❌ Error parsing user data:', error);
      return null;
    }
  },

  /**
   * Prüft ob User eingeloggt ist
   */
  isAuthenticated: () => {
    const token = authUtils.getToken();
    return !!token;
  },

  /**
   * Entfernt alle Auth-Daten (Logout)
   */
  clearAuth: () => {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('userId');
      localStorage.removeItem('userRole');
      localStorage.removeItem('subscriptionTier');
      localStorage.removeItem('tokenExpiry');
      localStorage.removeItem('viewingAsOrgId');
      
      console.log('🚪 Auth data cleared');
    } catch (error) {
      console.error('❌ Error clearing auth data:', error);
    }
  },

  /**
   * Holt Authorization Header für API Requests
   */
  getAuthHeader: () => {
    const token = authUtils.getToken();
    return token ? { 'Authorization': `Bearer ${token}` } : {};
  }
};